query sportsByIds($ids: [UUID!]) {
  allSports(filter: {sportId: {in: $ids}}) {
    nodes {
      sportId
      sportName
    }
  }
}
